import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Tooltip,
  Row,
  CardImg,
} from 'reactstrap';
import ImageGallery from '../../../propinfo/gallery/index';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_QuestionSets } from '../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
let arr = [];
export default function AutonomousReplies({
  integration,
  integrationProperties,
  allProperties,
  channelDetails,
  saveIntegration,
}) {
  const [assistantList, setAssistantList] = useState('');
  const [formatedProperties, setFormatedProperties] = useState([]);

  const [aiAssistant, setAIAssistant] = useState(
    channelDetails?.autonomousReplies?.assistantId
      ? channelDetails?.autonomousReplies?.assistantId
      : ''
  );
  const [selectedProperty, setSelectedProperty] = useState(
    integrationProperties.length > 0 ? integrationProperties[0] : ''
  );
  const [autonomousSettings, setAutonomousSettings] = useState(
    channelDetails?.autonomousReplies || {
      enabled: false,
      instructions: '',
      mode: '',
      versionGPT3: '',
      versionDynamicFlow: '',
      assistantEnabled: false,
      generativeChatGPT: false,
      assistantId: '',
    }
  );
  useEffect(() => {
    loadResponse();
  }, integration);

  useEffect(() => {
    const result = integrationProperties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    setFormatedProperties(result);
  }, [integrationProperties, allProperties]);

  const loadResponse = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${selectedProperty}&groupId=${getGroupID()}&lang=${'en'}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        var list = [];
        if (setslist !== null && setslist.length > 0) {
          setslist
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => {
              list.push({ id: l.openAiAssistantId, name: l.name });
            });
        }

        setAssistantList(list);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  };
  const handleSave = () => {
    channelDetails.autonomousReplies = autonomousSettings;
    saveIntegration({ channelDetails });
  };

  const handleAutonmousSettings = (e) =>
    setAutonomousSettings({ ...autonomousSettings, enabled: e });

  const handleAutonmousChange = (e) =>
    setAutonomousSettings({
      ...autonomousSettings,
      [e.target.name]: e.target.value,
    });

  const handleAutonmousModeChange = (e) =>
    setAutonomousSettings({
      ...autonomousSettings,
      mode: e,
    });

  const handleCheckedGenerativeGTP3 = (e) => {
    var feat = { ...autonomousSettings };
    feat.generativeChatGPT = e;
    feat.assistantEnabled = false;
    setAutonomousSettings(feat);
  };

  const handleChange = (event) => {
    setSelectedProperty(event.target.value);
  };

  const handleChangeAssistantId = (e) => {
    setAIAssistant(e.target.value);
    var feat = { ...autonomousSettings };
    feat.assistantId = e.target.value;
    setAutonomousSettings(feat);
  };

  const handleCheckedOpenAIEnabled = (e) => {
    var feat = { ...autonomousSettings };
    feat.generativeChatGPT = false;
    feat.assistantEnabled = e;
    setAutonomousSettings(feat);
  };

  const handleVersionDynamicFlowChange = (e) => {
    var feat = { ...autonomousSettings };
    feat.versionDynamicFlow = e;
    setAutonomousSettings(feat);
  };
  const handleVersionGPT3Change = (e) => {
    var feat = { ...autonomousSettings };
    feat.versionGPT3 = e;
    setAutonomousSettings(feat);
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Autonomous Replies</h6>
          </div>
          <Separator className="mb-3" />
          <div className="row mt-1 ml-2 mb-3">
            <Colxx md="12" className="mb-2">
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2 float-right"
                checked={autonomousSettings?.enabled}
                name="enabled"
                onChange={(e) => handleAutonmousSettings(e)}
              />
            </Colxx>
            <Colxx md="12">
              <div className="text-left">
                <h5 className=''>Autonomy Mode</h5>
                <div className=" mb-2">
                  <CustomInput
                    type="radio"
                    id="exAutoPilot"
                    name="AutoPilot"
                    label="Reply on auto pilot"
                    checked={autonomousSettings?.mode === 'AutoPilot'}
                    onChange={(e) => handleAutonmousModeChange('AutoPilot')}
                  />
                </div>
                <div className="mb-3 ">
                  <CustomInput
                    type="radio"
                    id="exHuman"
                    name="Human"
                    label="Human in the loop"
                    checked={autonomousSettings?.mode === 'Human'}
                    onChange={(e) => handleAutonmousModeChange('Human')}
                  />
                </div>

                <Separator className="mb-3" />
                <div className=" mb-3">
                  <h5 style={{ marginTop: '0.15rem' }}>Choose your NLP </h5>
                  <div className="d-flex ml-2 mt-2">
                    <h7 style={{ marginTop: '0.15rem' }}>Gen AI</h7>
                    <Switch
                      className="agentswitch custom-switch-primary custom-switch-small ml-2"
                      checked={autonomousSettings?.generativeChatGPT}
                      name="generativeChatGPT"
                      onChange={(e) => handleCheckedGenerativeGTP3(e)}
                    />
                  </div>
                  <div className="d-flex ml-2 mb-2 mt-2">
                    <h7 style={{ marginTop: '0.15rem', marginBottom: '4px' }}>
                      Dynamic Conversation Flow
                    </h7>
                    <Switch
                      className="agentswitch custom-switch-primary custom-switch-small ml-2"
                      checked={autonomousSettings?.assistantEnabled}
                      name="openAIisEnabled"
                      onChange={(e) => handleCheckedOpenAIEnabled(e)}
                    />
                  </div>
                </div>

                {autonomousSettings?.assistantEnabled === true &&
                  formatedProperties !== null && (
                    <Fragment>
                      {/* <Separator className="mb-3 mt-2" /> */}
                      {formatedProperties.length > 1 && (
                        <div className="mb-3  ">
                          <h6>Properties</h6>

                          <Input
                            className="border p-2 mb-3"
                            type={
                              formatedProperties.length > 1 ? 'select' : 'text'
                            }
                            name="Property Id"
                            value={
                              formatedProperties.length > 1
                                ? selectedProperty
                                : `${formatedProperties[0].name} (${formatedProperties[0].id})`
                            }
                            onChange={
                              formatedProperties.length > 1
                                ? handleChange
                                : undefined
                            }
                          >
                            {formatedProperties.length > 1 ? (
                              formatedProperties.map((list, index) => (
                                <option key={index} value={list.id}>
                                  {`${list.name} (${list.id})`}
                                </option>
                              ))
                            ) : (
                              <>{`${formatedProperties[0].name} (${formatedProperties[0].id})`}</>
                            )}
                          </Input>
                        </div>
                      )}
                    </Fragment>
                  )}
                {assistantList &&
                  assistantList !== null &&
                  autonomousSettings?.assistantEnabled === true && (
                    <Fragment>
                      {/* <Separator className="mb-3" /> */}
                      <div className=" mb-3">
                        <h6>Dynamic Conversation Flow</h6>
                        {assistantList.length > 0 ? (
                          <Input
                            className="border p-2 mb-3"
                            type="select"
                            name="assistantId"
                            placeholder="Dynamic Conversation Flow"
                            value={aiAssistant}
                            onChange={handleChangeAssistantId}
                          >
                            <option value="">
                              Select a Dynamic Conversation Flow
                            </option>
                            {assistantList.map((assist, index) => (
                              <option key={index} value={assist.id}>
                                {`${assist.name} (${assist.id})`}
                              </option>
                            ))}
                          </Input>
                        ) : (
                          <Input
                            className="border p-2 mb-3"
                            type="text"
                            name="assistantId"
                            onChange={handleChangeAssistantId}
                            placeholder="Dynamic Conversation Flow"
                            defaultValue={aiAssistant}
                          />
                        )}
                        <Input
                          type="select"
                          name="versionDynamicFlow"
                          value={autonomousSettings?.versionDynamicFlow}
                          onChange={(e) =>
                            handleVersionDynamicFlowChange(e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          <option value="6DynamicConverstionFlow">
                            Version 6 (with Dynamic Conversation Flow)
                          </option>
                        </Input>
                      </div>
                    </Fragment>
                  )}
                {autonomousSettings.generativeChatGPT && (
                  <Fragment>
                    {/* <Separator className="mb-3" /> */}
                    <div className=" ml-2 text-center mb-3">
                      {/* <b>Select Version</b>
                      <br /> */}
                      <Input
                        type="select"
                        name="version"
                        value={autonomousSettings?.versionGPT3}
                        onChange={(e) =>
                          handleVersionGPT3Change(e.target.value)
                        }
                      >
                        <option value="">Select version</option>
                        <option value="6">Version 6</option>
                      </Input>
                    </div>
                  </Fragment>
                )}
                <Fragment>
                  {autonomousSettings.generativeChatGPT && (
                    <Fragment>

                      <div className="mb-3 mt-2">
                        <h6>Generative AI (GPT) instructions for Email</h6>
                        <p className="my-2">
                          Hint: Add a line that’s appended to every customer
                          query before sending it to the GPT models. This
                          provides guidance to the model.
                        </p>
                        <Input
                          className="form-control"
                          name="instructions"
                          type="textarea"
                          placeholder="You are a phone assistant working for the Paradise Resort. Be truthful and precise."
                          defaultValue={autonomousSettings?.instructions}
                          onChange={(e) => {
                            handleAutonmousChange(e);
                          }}
                        />
                      </div>
                    </Fragment>
                  )}
                </Fragment>
              </div>
            </Colxx>
          </div>
          <Separator className="mb-2" />
          <Colxx md="12" className="text-center mb-2">
            <Button
              onClick={() => handleSave()}
              color="primary"
              size="xs"
              outline
            >
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
